import React from 'react';
import { Icon } from './Icon.js';
export const IconAlign2HorizontalFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,12c-.414,0-.75-.336-.75-.75V.75c0-.414.336-.75.75-.75s.75.336.75.75v10.5c0,.414-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("rect", { x: "1.5", y: "3", width: "9", height: "6", rx: "1.75", ry: "1.75", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconAlign2HorizontalFill12.js.map